import React from "react"
import PropTypes from "prop-types"
import withStyles from "@material-ui/core/styles/withStyles"
import { Circle, Polygon, Rectangle } from "react-leaflet"

const styles = () => ({})

const MasterMarker = ({
	selected,
	center,
	radius,
	onClick: handleClick,
	onMouseOver,
	onMouseOut,
	markerColor,
	markerFill,
	timestamp,
}) => {
	if (center.length !== 2) return null
	const twoHoursInMilliseconds = 2 * 60 * 60 * 1000
	//Checking if master data is older than 2 hours
	const isGreaterTwoHours = timestamp && Date.now() - timestamp * 1000 > twoHoursInMilliseconds
	const bounds = [
		[center[0] - radius, center[1] - radius],
		[center[0] + radius, center[1] + radius],
	]
	const y = center[0] + radius * -2
	const x = center[1]

	return (
		<>
			<Rectangle
				key={`${center[0]}-${center[1]}-${selected}`}
				bounds={bounds}
				color={markerColor}
				fillColor={markerFill}
				onClick={handleClick}
				onMouseOver={onMouseOver}
				onMouseOut={onMouseOut}
			/>

			{isGreaterTwoHours && <ExclamationIcon x={x} y={y} width={radius / 1} height={radius * 5} />}
		</>
	)
}

MasterMarker.propTypes = {
	classes: PropTypes.object.isRequired,
	center: PropTypes.array.isRequired,
	radius: PropTypes.number.isRequired,
	onClick: PropTypes.func,
	onMouseOver: PropTypes.func,
	onMouseOut: PropTypes.func,
	markerColor: PropTypes.string.isRequired,
	markerFill: PropTypes.string.isRequired,
	selected: PropTypes.bool.isRequired,
	timestamp: PropTypes.number,
}

export default withStyles(styles)(MasterMarker)

const ExclamationIcon = ({ width = 4, height = 10, x, y }) => {
	const markerPosition = [
		[y, x],
		[y, x + width],
		[y - height, x + width * 0.75],
		[y - height, x + width * 0.25],
		[y, x],
	]
	const circleCenter = [y - height - width * 3, x + width / 2]
	return (
		<>
			<Polygon color="#FFBE40" fillOpacity="1" fillColor="#FFBE40" positions={markerPosition} />
			<Circle color="#FFBE40" fillOpacity="1" fillColor="#FFBE40" center={circleCenter} radius={width} />
		</>
	)
}
ExclamationIcon.propTypes = {
	width: PropTypes.number,
	height: PropTypes.number,
	x: PropTypes.number,
	y: PropTypes.number,
}
